import { DailyReportRoadStateTypes, DailyReportRoadActionTypes } from "./DailyReportRoad.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DailyReportRoadStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const DailyReportRoadReducer = (
  state: DailyReportRoadStateTypes = INITIAL_STATE,
  action: any
): DailyReportRoadStateTypes => {
  switch (action.type) {
    case DailyReportRoadActionTypes.FETCH_ALL_DAILY_REPORT_ROAD:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyReportRoadActionTypes.FETCH_ALL_DAILY_REPORT_ROAD_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyReportRoadActionTypes.FETCH_ALL_DAILY_REPORT_ROAD_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyReportRoadActionTypes.FETCH_ALL_DAILY_REPORT_ROAD_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case DailyReportRoadActionTypes.FETCH_ONE_DAILY_REPORT_ROAD:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyReportRoadActionTypes.FETCH_ONE_DAILY_REPORT_ROAD_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyReportRoadActionTypes.FETCH_ONE_DAILY_REPORT_ROAD_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyReportRoadActionTypes.FETCH_ONE_DAILY_REPORT_ROAD_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DailyReportRoadReducer;
